__turbopack_context__.v({
  "className": "fredoka_e925b192-module__yFDtmG__className",
});
